import React, { Component } from 'react';
import "./styles.scss";
import { Form } from 'semantic-ui-react';
import DatePicker from 'antd/es/date-picker';
import 'antd/es/date-picker/style/index.css';
import moment from 'moment';
import 'moment/locale/vi';
import { connect } from 'react-redux';
import { withTranslation } from "react-i18next";
import { compose } from 'redux';
const { MonthPicker } = DatePicker;

class ApproveForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().format('MM-YYYY')
        }
    }

    componentWillReceiveProps(nextProps) {}

    handleKeyDown = (event) => {
        if (event.keyCode === 8 || event.keyCode === 46) {
            event.preventDefault();
        }
    }

    monthRender = (date, locale) => {
        return <span>{date.month() + 1}</span>;
    }

    setMonth = (date, dateString) => {
        this.props.searchApproveList(moment(dateString, 'MMYYYY').format('YYYY-MM'));
    }

    render() {
        const { t } = this.props;
        return (
            <div className="month-picker">
                <Form autoComplete="off">
                    <Form.Group inline>
                        <label></label>
                        <MonthPicker 
                            format="MM-YYYY"
                            defaultValue={moment(this.props.paramDate, 'YYYY-MM')}
                            monthCellContentRender={this.monthRender}
                            onChange={this.setMonth}
                            allowClear={false}
                            size="small"
                            suffixIcon={<i className="calendar icon"></i>}
                        />
                    </Form.Group>
                </Form>
            </div>
        );
    }
}

const mapStateToProps = state => ({
})

const mapDispatchToProps = dispatch => ({
})

export default compose(
    withTranslation(),
    connect(mapStateToProps, mapDispatchToProps)
)(ApproveForm);
